<div class="flex column justify-space-between root">
    <div class="flex column items">
        @for (annotation of annotations$ | async; track annotation.id; let i = $index) {
            <frog-annotation-list-item
                [annotation]="annotation"
                [asset]="asset"
                [class.active]="i === selected"
                (click)="select(i, annotation)"
            ></frog-annotation-list-item>
        }
    </div>
    <div class="add">
        <form [formGroup]="form">
            <mat-form-field appearance="fill">
                <mat-label>Add Annotation</mat-label>
                <textarea matInput formControlName="comment" (input)="onInput($event)" (keydown)="onKeydown($event)"></textarea>
            </mat-form-field>

            <div class="flex row justify-space-between actions">
                @if (playbackState$ | async; as playbackState) {
                    @if (asset?.asset_type === 2) {
                        <mat-checkbox formControlName="includeFrame">Include Frame</mat-checkbox>
                    }
                    <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="addComment(playbackState.frame, playbackState.frameRate)">
                        Post Comment
                    </button>
                }
            </div>
        </form>
    </div>
</div>
